<template>
    <div class="product-item">
        <router-link :to="'/product/'+item.spuId+'/'+item.skuId" class="img-box">
            <img v-if="item.imageUrl" :src="item.imageUrl +'?x-oss-process=image/resize,m_pad,h_300,w_300,color_FFFFFF'"
                 :alt="item.name">
            <img v-if="item.imgUrl" :src="item.imgUrl +'?x-oss-process=image/resize,m_pad,h_300,w_300,color_FFFFFF'"
                 :alt="item.name">
        </router-link>
        <div class="item-info">
            <router-link :to="'/product/'+item.spuId+'/'+item.skuId" class="name">
                {{item.name}}
            </router-link>
            <div class="sku-tip" v-for="tip in item.skuTip">
                <span>{{tip.item}}</span>
            </div>
        </div>
<!--        <div class="price">￥{{item.price/100 | number_format}}</div>-->
        <div class="num">{{item.num}} 件</div>
    </div>
</template>

<style lang="scss" type="text/scss" scoped>
    $height: 200px;
    .product-item {
        @include clearfix;
        font-size: 14px;
        line-height: 1.6;
        display: flex;
        align-items: center;

        .img-box {
            float: left;
            display: inline-block;
            width: 200px;
            height: $height;
            text-align: center;

            img {
                max-width: 100%;
                max-height: 100%;
                height: auto;
            }
        }

        .item-info {
            float: left;
            width: 320px;
            height: $height;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .name {
                @include SourceHanSerifSC-bold;
                font-size: 16px;
                margin-bottom: 5px;
            }

            .code, .size {
                font-size: 11px;
                color: #B8B8B8;
            }

            .code {
                margin-bottom: 5px;
            }
        }

        .price {
            color: $primary-color;
        }

        .price, .num {
            display: inline-block;
            width: 200px;
            text-align: center;
        }
    }
</style>

<script>
    export default {
        data() {
            return {}
        },
        props: {
            item: {
                type: Object,
                default() {
                    return {
                        name: '',
                        skuId: '',
                        imgUrl: '',
                        code: '',
                        size: '',
                        skuTip: [],
                        num: ''
                    }
                }
            }
        }
    }
</script>
